<template>
  <b-row>
    <b-col cols="12">
      <b-form-group>
        <v-select v-if="categories != null" v-model="selected" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          label="title" :options="categories" class="select-size-lg" single>
          <template #option="{ title, description }">
            <span> {{ title }}</span><br />
            <small class="text-muted"> {{ description }} </small>
          </template>
        </v-select>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol, BFormGroup } from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import axios from '@axios'
export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    vSelect,
  },

  props: {
    initialtag: null,
    surveyInfo: null,
  },

  methods: {
    updateSelections(a) {

      //console.log(a);
    },
    fetchCategories() {
      if (this.surveyInfo == null || this.surveyInfo == undefined) {
        return;
      }
      return new Promise((resolve, reject) => {
        axios
          .get('/survey/admin/getallquestiontags?t=' + this.surveyInfo.SurveyTypeId)
          .then((response) => {


            var data = response.data;
            var responseData = JSON.parse(JSON.stringify(data));
            this.categories = responseData.data;
            if (this.initialtag == null || this.initialtag.length == 0) {
              this.selectedinitialtag = this.categories[0];
            }
          }
          )
          .catch(error => reject(error))
      })
    },
  },
  watch: {
    // whenever question changes, this function will run
    surveyInfo(newQuestion, oldQuestion) {
      //console.log("survey surveyInfo updated");
      this.fetchCategories();
    },
    selected: function (newVal, coldVal) {

      this.$emit("selectionChanged", newVal);

    },
    initialtag:
    {
      handler(newVal, coldVal) {
        //console.log("initial tag changed");
        this.selected = newVal;
      },
      deep: true
    }
  },
  created() {
    this.fetchCategories();
    //console.log("Question tag updated");
    this.selectedinitialtag = this.initialtag

  },
  data() {
    return {
      categories: null,
      selectedinitialtag: null,
      selected: this.initialtag,
      option: [{ title: 'Square' }, { title: 'Rectangle' }, { title: 'Rombo' }, { title: 'Romboid' }],
    }
  }


}
</script>